import { gql } from '@apollo/client';
import AZSAPP_CLASSROOM_SETTINGS_FRAGMENT from 'graph/fragments/azsapp-classroom-settings';

const GET_AZSAPP_CLASSROOM_SETTINGS = gql`
  query azsappClassroomSettings($where: PliClassroomSettingsWhereInput!) {
    azsappClassroomSettings(where: $where) {
      ...BaseAzsappClassroomSettings
    }
  }
  ${AZSAPP_CLASSROOM_SETTINGS_FRAGMENT}
`;

export default GET_AZSAPP_CLASSROOM_SETTINGS;
